// extracted by mini-css-extract-plugin
export var emailInput = "NewsletterSignUpForCareers-module--email-input--a602a";
export var emailInputFieldError = "NewsletterSignUpForCareers-module--email-input-field-error--6df7f";
export var errorText = "NewsletterSignUpForCareers-module--error-text--161d2";
export var form = "NewsletterSignUpForCareers-module--form--6d3a5";
export var loadingRoot = "NewsletterSignUpForCareers-module--loading-root--1c651";
export var loadingText = "NewsletterSignUpForCareers-module--loading-text--ecfe0";
export var notice = "NewsletterSignUpForCareers-module--notice--3467b";
export var status = "NewsletterSignUpForCareers-module--status--77445";
export var successIcon = "NewsletterSignUpForCareers-module--success-icon--04b05";